import type { Store } from '@/stores/types/store.types'

/**
 * Normalize a store object from API (StoreSummary or StoreDetailDto) to UI-friendly shape.
 * Shared between the Pinia store and discovery sections that call the API directly.
 */
export function normalizeStore(s: unknown = {}): Store {
  const raw = (s || {}) as Record<string, any>
  return {
    id: raw.slug || raw.id,
    slug: raw.slug || raw.id,

    name: raw.name || '',
    description: raw.description || '',
    category: (Array.isArray(raw.tags) && raw.tags[0]?.name) || raw.category || '',
    tagline: raw.tagline || '',

    logoUrl: raw.logoUrl || raw.logo || null,
    bannerUrl: raw.bannerUrl || raw.banner || null,

    rating: raw.stats?.averageRating ?? raw.rating ?? 0,
    reviewCount: raw.stats?.totalReviews ?? raw.reviewCount ?? 0,
    // Backend stats.totalProducts is an aggregate store stat and may differ from
    // category-derived catalog totals used in store detail browse UI.
    productsCount: raw.stats?.totalProducts ?? raw.productsCount ?? raw.productCount ?? 0,
    followersCount: raw.stats?.totalFollowers ?? raw.followersCount ?? 0,
    totalOrders: raw.totalOrders ?? raw.total_orders ?? 0,
    storeCreatedAt: raw.storeCreatedAt ?? raw.store_created_at ?? undefined,

    settings: {
      ...raw.settings,
      isActive: raw.isActive ?? raw.settings?.isActive,
      preparationTime: raw.settings?.preparationTime ?? raw.settings?.orderPreparationTime ?? undefined,
    },

    tags: raw.tags || [],
    contactPhone: raw.contactPhone,
    contactEmail: raw.contactEmail,
    businessHours: raw.businessHours,
  }
}
